import { Component } from 'preact';
import style from './styles/RaffleCarousel.scss';
import { connect } from 'react-redux';
import RaffleCarouselController from './RaffleCarouselController';
import { showPreviousAction, showNextAction, setActiveIndexAction } from '../../actions/CarouselActions';
import { bindActionCreators } from 'redux';
import RaffleCarouselSlide from './RaffleCarouselSlide';
import BlurredBackground from './BlurredBackground';

/**
 * @property {Raffle[]} props.raffles
 * @property {number} props.activeIndex
 */
// eslint-disable-next-line react/prefer-stateless-function
class RaffleCarousel extends Component {

	/**
	 * @type ?number Interval Id
	 */
	interval = null;

	change = () => {
		this.props.showNextAction();
	};

	componentDidMount() {
		this.interval = setInterval(this.change, 15000);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.activeIndex !== this.props.activeIndex) {
			clearInterval(this.interval);
			this.interval = setInterval(this.change, 15000);
		}
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	render({ raffles, activeIndex, loaded }) {
		const raffle = typeof raffles[activeIndex] === 'undefined' ? null : raffles[activeIndex];

		return (
			<div className={style.carousel}>
				<BlurredBackground raffle={raffle} />
				<div className="container no-padding">
					<RaffleCarouselSlide {...{ loaded, raffle  }} />
					{raffles.length > 1
						? (<div className={style['controller-wrapper']}>
							<RaffleCarouselController {...{ raffles, activeIndex }} />
						</div>)
						: null
					}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const { homepage } = state;
	return {
		raffles: homepage.carouselRaffles.items,
		activeIndex: homepage.carouselRaffles.activeIndex,
		size: homepage.carouselRaffles.items.length,
		loaded: homepage.loaded
	};
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ showNextAction, showPreviousAction, setActiveIndexAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RaffleCarousel);



// WEBPACK FOOTER //
// ./components/raffle/RaffleCarousel.js